import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
var Icon = function(props) {
    return /*#__PURE__*/ _jsx("img", {
        src: "/images/okx-wallet.png",
        style: {
            width: "40px",
            height: "40px",
            padding: "4px"
        }
    });
};
export default Icon;
